import { RouteProps } from 'react-router-dom';
import { SubscriptionFeatureFlag } from '@mm/state/controllers/FeatureFlags';
import { landmineNames } from '@mm/constants/landmine-names';
import { NativeIntegrations } from './NativeIntegrations/NativeIntegrations';
import { EmailIntegration } from './NativeIntegrations/components/EmailIntegrations/EmailIntegration';
import { SlackIntegrations } from './NativeIntegrations/components/SlackIntegrations/SlackIntegrations';
import { ContactSuppression } from './NativeIntegrations/components/ContactSuppressions/ContactSuppression';
import { XRayIntegrations } from './NativeIntegrations/components/XRayIngegrations/XRayIntegrations';
import { FacebookAdsIntegrations } from './NativeIntegrations/components/FacebookAdsIntegrations/FacebookAdsIntegrations';
import { IntegrationLinkType } from './IntegrationsPanel/IntegrationsPanel';
import { GoogleAdsIntegrations } from './NativeIntegrations/components/GoogleAdsIntegrations/GoogleAdsIntegrations';
import { CaptureActionEnum } from '@mm/state/model/SuppressionSettingsModel';

export type PageSettingDefinition = {
  id: IntegrationLinkType;
  name: string;
  subtitle: string;
  component: RouteProps['component'];
  requiredFeature?: SubscriptionFeatureFlag;
  landmineName: string;
  helpDoc?: string;
};

export const IntegrationErrors = [
  'merge fields were invalid',
  'api key Invalid',
  'invalid_grant',
  'exceeds grid limits',
];

export const INTEGRATIONS_SECTIONS: PageSettingDefinition[] = [
  {
    id: 'email',
    name: 'Email Outbound Tools',
    subtitle:
      'Connect email accounts to contact your leads with outbound automations',
    component: EmailIntegration,
    requiredFeature: 'nativeIntegrations',
    landmineName: landmineNames.INTEGRATIONS_EMAIL,
    helpDoc:
      'https://customers.ai/help/l/en/article/z3rhglizny-e-mail-integration',
  },
  {
    id: 'native-integrations',
    name: 'CRM connections',
    subtitle: 'Send leads directly to your CRM',
    component: NativeIntegrations,
    requiredFeature: 'nativeIntegrations',
    landmineName: landmineNames.INTEGRATIONS_NATIVE_INTEGRATIONS,
    helpDoc: 'https://customers.ai/help/l/en/category/06p3o5upol-integrations',
  },
  {
    id: 'contact-suppression',
    name: 'Existing Contact Suppression',
    subtitle: 'Upload your existing contacts to suppress contact creation',
    component: () =>
      ContactSuppression({ captureAction: CaptureActionEnum.do_not_send }),
    landmineName: landmineNames.INTEGRATIONS_CONTACT_SUPPRESSION,
    requiredFeature: 'contactSuppression',
    helpDoc:
      'https://customers.ai/help/l/en/article/uhl81gxos2-enable-email-suppression-list',
  },
  {
    id: 'unsubscribe-list',
    name: 'Unsubscribe List',
    subtitle:
      'Upload lists of contacts that you do not want to track any data or engagement on',
    component: () =>
      ContactSuppression({
        captureAction: CaptureActionEnum.do_not_capture,
      }),
    landmineName: landmineNames.INTEGRATIONS_UNSUBSCRIBE_LIST,
    requiredFeature: 'contactSuppression',
    helpDoc:
      'https://customers.ai/help/l/en/article/uhl81gxos2-enable-email-suppression-list',
  },
  {
    id: 'facebook',
    name: 'Facebook ',
    subtitle:
      'Send leads directly to Facebook for retargeting, Lookalikes, and audience building',
    component: FacebookAdsIntegrations,
    landmineName: landmineNames.INTEGRATIONS_FACEBOOK_ADS,
    requiredFeature: 'fbRestore',
    helpDoc: '',
  },
  {
    id: 'google-ads',
    name: 'Google Ads ',
    subtitle: 'Send leads directly to Google Ads',
    component: GoogleAdsIntegrations,
    landmineName: landmineNames.INTEGRATIONS_GOOGLE_ADS,
    requiredFeature: 'fbRestore',
    helpDoc: '',
  },
  {
    id: 'notifications',
    name: 'Notifications',
    subtitle: 'Get alerts directly to your Slack channel',
    component: SlackIntegrations,
    requiredFeature: 'nativeIntegrations',
    landmineName: landmineNames.INTEGRATIONS_NOTIFICATIONS,
    helpDoc: '',
  },
  {
    id: 'xray',
    name: 'X-Ray Pixel',
    subtitle: 'Capture leads form your anonymous website visitors',
    component: () => XRayIntegrations({}),
    requiredFeature: 'xray',
    landmineName: landmineNames.INTEGRATIONS_XRAY,
    helpDoc:
      'https://customers.ai/help/l/en/article/16hdqqv4tu-x-ray-installation-guide',
  },
];
